 <!-- Encabezado con imágen -->
 <div class="breadcaump-area bg_image--57 ptb--270 ptb-md--150 ptb-sm--150 breadcaump-title-bar breadcaump-title-white">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="breadcaump-inner text-center mt_sm--50 mt_md--50">
                    <h1 class="heading heading-h1 text-white">DISFRUTA DE TODOS <br> NUESTROS BENEFICIOS</h1>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Start Career Area -->
 <div class="brook-career-area pb--70 space_dec--100 pt_md--70 pt_sm--70">
    <div class="container">
        <div class="row">

            <!-- Start Single Career -->
            <div class="col-lg-6 col-md-6 col-12">
                <div class="career mb--30">
                    <div class="inner">

                        <div class="title">
                            <h3 class="heading heading-h3 text-color-1">NeuroAkashico<sup>®</sup></h3>
                        </div>

                        <div class="content mt--35">
                            <h6 class="heading heading-h6">NUESTRO OBJETIVO</h6>
                            <div class="desc mt--25">
                               
                                <div class="bkseparator--25"></div>
                                <p class="bk_pra">Transmitir, practicar y enseñar herramientas de conocimiento, crecimiento personal, inteligencia y conciencia ilimitada aplicada.</p>
                            </div>
                        </div>

                        <div class="career-list mt--65">
                            <h6 class="heading heading-h6">BENEFICIOS:</h6>
                            <!-- Start Single List -->
                            <div class="bk-list--2 move-up wow mt--35">
                                <div class="list-header with-ckeck">
                                    <div class="marker dark-color"></div>
                                    <div class="title-wrap">
                                        <h6 class="heading heading-h5">Conferencias</h6>
                                    </div>
                                </div>
                                <div class="list-header with-ckeck">
                                    <div class="marker dark-color"></div>
                                    <div class="title-wrap">
                                        <h6 class="heading heading-h5">Certificación Internacional </h6>
                                    </div>
                                </div>

                                <div class="list-header with-ckeck">
                                    <div class="marker dark-color"></div>
                                    <div class="title-wrap">
                                        <h6 class="heading heading-h5">Plataforma E-Learning</h6>
                                    </div>
                                </div>

                                <div class="list-header with-ckeck">
                                    <div class="marker dark-color"></div>
                                    <div class="title-wrap">
                                        <h6 class="heading heading-h5">Congreso Virtual y Presencial</h6>
                                    </div>
                                </div>

                                <div class="list-header with-ckeck">
                                    <div class="marker dark-color"></div>
                                    <div class="title-wrap">
                                        <h6 class="heading heading-h5">Tienda Virtual </h6>
                                    </div>
                                </div>

                                <div class="list-header with-ckeck">
                                    <div class="marker dark-color"></div>
                                    <div class="title-wrap">
                                        <h6 class="heading heading-h5">Parque Temático</h6>
                                    </div>
                                </div>
                                   
                                   <div class="list-header with-ckeck">
                                    <div class="marker dark-color"></div>
                                    <div class="title-wrap">
                                        <h6 class="heading heading-h5">Cafebreria</h6>
                                    </div>
                                </div>

                            </div>
                            <!-- End Single List -->
                            <div class="career-btn mt--60">
                                <a class="brook-btn bk-btn-dark btn-sd-size btn-rounded space-between" href="/contacto">Contactar</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- End Single Career -->

            <!-- Start Single Career -->
            <div class="col-lg-6 col-md-6 col-12">
                <div class="career mb--30">
                    <div class="inner">

                        <div class="title">
                            <h3 class="heading heading-h3 text-color-2">Contacto</h3>
                        </div>

                        <div class="content mt--35">
                            <h6 class="heading heading-h6">UBÍCANOS:</h6>
                            <div class="desc mt--25">
                             
                                <div class="bkseparator--25"></div>
                                <p class="bk_pra">Oficinas Centrales Escuela Akashica® Avenida Río Mississippi #49, Piso 14, int. 1402 Col. Cuahtémoc C.P. 06500 Ciudad de México <br>
                                Akashic School Inc, 1549 NE 123RD ST, North Miami, Fl 33161, <br>Contacto: (521) 961 181 16 08</p>
                            </div>
                        </div>

                        <div class="career-list mt--65">
                            <h6 class="heading heading-h6">MÁS BENEFICIOS</h6>
                            <!-- Start Single List -->
                            <div class="bk-list--2 move-up wow mt--35">
                                <div class="list-header with-ckeck">
                                    <div class="marker dark-color"></div>
                                    <div class="title-wrap">
                                        <h6 class="heading heading-h5">Radio</h6>
                                    </div>
                                </div>
                                <div class="list-header with-ckeck">
                                    <div class="marker dark-color"></div>
                                    <div class="title-wrap">
                                        <h6 class="heading heading-h5">Salas </h6>
                                    </div>
                                </div>

                                <div class="list-header with-ckeck">
                                    <div class="marker dark-color"></div>
                                    <div class="title-wrap">
                                        <h6 class="heading heading-h5">Festivales</h6>
                                    </div>
                                </div>

                                <div class="list-header with-ckeck">
                                    <div class="marker dark-color"></div>
                                    <div class="title-wrap">
                                        <h6 class="heading heading-h5">Ferias</h6>
                                    </div>
                                </div>

                                <div class="list-header with-ckeck">
                                    <div class="marker dark-color"></div>
                                    <div class="title-wrap">
                                        <h6 class="heading heading-h5">App</h6>
                                    </div>
                                </div>

                                <div class="list-header with-ckeck">
                                    <div class="marker dark-color"></div>
                                    <div class="title-wrap">
                                        <h6 class="heading heading-h5">Niños</h6>
                                    </div>
                                </div>
                                    <div class="list-header with-ckeck">
                                    <div class="marker dark-color"></div>
                                    <div class="title-wrap">
                                        <h6 class="heading heading-h5">Empresas y Negocios</h6>
                                    </div>
                                </div>

                            </div>
                            <!-- End Single List -->
                            <div class="career-btn mt--60">
                                <a class="brook-btn bk-btn-dark btn-sd-size btn-rounded space-between" href="/neuroakashico">Ver cursos</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- End Single Career -->


        </div>
    </div>
</div>
<!-- End Career Area -->

